module.exports = __webpack_public_path__ + "static/media/sort-arrow-desc.04c37dab.svg";